import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerDropdownResult, EmployeeDropdownResult, GetCustomersInput, GetProjectsInput, GetTagsInput, GetTicketTypesInput, GetTicketsInput, Priority, ProjectResult, Result, ResultList, SecurityLevelEnum, SortOrder, TableHeader, TagResult, TicketHasChangedEventInput, TicketResult, TicketSortType, TicketStatus, TicketTypeResult, UserMode } from 'app/models';
import { CustomerService, CustomerEmployeeService, EmployeeService, ProjectService, TagService, TicketService, TicketTypeService } from 'app/services';
import { Utility } from 'app/shared';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';

@Component({
  selector: 'app-ticket-list',
  templateUrl: './ticket-list.component.html',
  styleUrls: ['./ticket-list.component.scss']
})
export class TicketListComponent implements OnInit, AfterViewChecked {
  public ticketId: Number = 0;


  public result: Result = new Result();
  public isBusy: boolean;

  public priority = Priority;
  public utility = Utility;
  public sortOrder = SortOrder;
  public priorityEnum = Priority;
  public ticketStatus = TicketStatus;
  public employeeDropdown: Array<EmployeeDropdownResult>;
  public tableHeaders: Array<TableHeader<TicketSortType>>;
  public ticketTypeResultList: ResultList<TicketTypeResult>;
  public userMode: UserMode = UserMode.CustomerEmployee;

  public fromDateSearch: moment.Moment[] = [];
  public fromDateSearch2: string = '';
  public toDateSearch: moment.Moment[] = [];
  public toDateSearch2: string = '';
  public getTicketTypesInput: GetTicketTypesInput;

  public token: string;
  public ticketIdForHistory = 0;
  public permissionEmployee = 0;
  public clientIdForAssignedEmployee = 0;
  public isTicketLoaded: boolean;
  public isAdmin: boolean = false;
  public isSelectedEmployee: boolean = false;
  public ticket?: TicketResult | null;
  public projectNumber: number;
  public getTicketsInput: GetTicketsInput;
  public tagList: Array<TagResult>;
  public customerList: Array<CustomerDropdownResult>;
  public projectList: Array<ProjectResult>;
  public allProjectList = new Array<ProjectResult>();
  public getprojectList: Array<ProjectResult>;
  public ticketResultList: ResultList<TicketResult>;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private ticketService: TicketService,
    private tagService: TagService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private projectService: ProjectService,
    private customerEmployeeService: CustomerEmployeeService,
    private employeeService: EmployeeService,
    private ticketTypeService: TicketTypeService
  ) {
    this.isBusy = false;
    this.ticket = null;
    this.isTicketLoaded = false;
    this.projectNumber = 0;
    this.result = new Result();
    this.tagList = new Array<TagResult>();
    this.getTicketsInput = new GetTicketsInput();
    this.customerList = new Array<CustomerDropdownResult>();
    this.projectList = new Array<ProjectResult>();
    this.getprojectList = new Array<ProjectResult>();
    this.ticketResultList = new ResultList<TicketResult>();
    this.employeeDropdown = new Array<EmployeeDropdownResult>();
    this.getTicketTypesInput = new GetTicketTypesInput();
    this.ticketTypeResultList = new ResultList<TicketTypeResult>();

    this.token = Utility.getTokenType();
    this.tableHeaders = new Array<TableHeader<TicketSortType>>();

    this.tableHeaders.push(
      new TableHeader(TicketSortType.Id, 'Code', true),
      new TableHeader(TicketSortType.Title, 'Title', true),
      new TableHeader(TicketSortType.CustomerName, 'Customer', true),
      new TableHeader(TicketSortType.ProjectName, 'Project', true),
      new TableHeader(TicketSortType.Priority, 'Priority', true),
      new TableHeader(TicketSortType.TicketStatus, 'Status', true),
      new TableHeader(TicketSortType.CreationDateTime, 'CreationDateTime', true),
      new TableHeader(TicketSortType.CreatorUserFullName, 'CreatorUserFullName', true),
      new TableHeader(TicketSortType.AssignedEmployeeFullName, 'Assignee', true),
      new TableHeader(TicketSortType.EditDateTime, 'EditDateTime', true)
    );
    if (this.token === 'dashboardToken') {
      this.tableHeaders.push(new TableHeader(TicketSortType.TicketTypeName, 'TicketType', true));
    }
  }

  ngOnInit(): void {
    if (this.token === 'dashboardToken') {
      this.employeeService.checkPermission().then(permissionResult => {
        if (permissionResult.success != true)
          this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
        else {
          this.permissionEmployee = permissionResult.data.id
          this.isAdmin = Utility.isAccessable(permissionResult.data.securityLevel, SecurityLevelEnum.TeamLead) ?? false;
          if(!this.isAdmin)
          {
            this.getTicketsInput.assignedEmployeeId = this.permissionEmployee
            this.isSelectedEmployee = true;
          }
          this.loadFormPreRequirements();
          this.loadEmployees();
          this.loadTags();
          this.params();
        }
      }).catch(c => {
        this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
      });
    } else {
      this.customerEmployeeService.checkPermission().then(permissionResult => {
        if (permissionResult.success != true)
          this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
        else {
          this.getTicketsInput.customerId = 0;
          this.getProjectsWithCustomerId();
          this.loadData();
        }
      }).catch(c => {
        this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
      });
    }
  }

  private params(): void {
    this.activatedRoute.params.forEach(param => {
      if (param.hasOwnProperty('ticketId') == true) {
        this.ticketId = +param['ticketId'];
      }
      if(this.ticketId != 0) 
        {
          this.getTicketsInput.searchText = this.ticketId.toString();
          this.loadData();
        }
    });
  }

  ngAfterViewChecked(): void {
    if (this.isTicketLoaded === true) {
      this.isTicketLoaded = false;

      const element = document.getElementById('ticketComment');
      const top = element!.getBoundingClientRect().top + window.pageYOffset - 100;
      const scrollToOptions: ScrollToOptions = {
        behavior: 'smooth',
        top: top
      };

      window.scrollTo(scrollToOptions);
    }
  }

  private loadFormPreRequirements(): Promise<void> {
    const customers = this.customerService.getCustomerdropdown()
      .then(result => {
        if (result.success == true) {
          this.customerList = result.data;
        } else {
          this.result = result;
        }
      });

    const getProjectsInput = new GetProjectsInput();
    getProjectsInput.paginationInformation.currentPage = 0;
    const projects = this.projectService.getProjects(getProjectsInput)
      .then(result => {
        if (result.success == true) {
          this.allProjectList = result.data;
        } else {
          this.result = result;
        }
      });

    return Promise.all([customers, projects]).then(() => {
      this.loadData();
    });
  }

  public loadTags(): void {
    const getTagsInput = new GetTagsInput();
    getTagsInput.paginationInformation.currentPage = 0;
    this.tagService.getTags(getTagsInput)
      .then(result => {
        if (result.success == true) {
          this.tagList = result.data;
        }
        else
          this.result = result;
      });
  }

  public loadData(): void {
    this.ticket = null;
    if (this.isBusy == false) {
      this.isBusy = true;
      if (this.fromDateSearch.length > 0)
        this.getTicketsInput.fromDate = moment(this.fromDateSearch[0], 'YYYY-MM-DD').utc(false);
      if (this.toDateSearch.length > 0)
        this.getTicketsInput.toDate = moment(this.toDateSearch[0], 'YYYY-MM-DD').utc(false);
      this.ticketService.getTickets(this.getTicketsInput, this.token).then(result => {
        if (result.success == true) {
          this.ticketResultList = result;
          this.ticketResultList.data.forEach(t => {
            this.ticketService.getTicketCommentUserMode(t.id).then(result => {
              if (result.success == true) {
                t.commentCount = result.data.commentCount;
                t.lastComment = result.data.ticketUserMode;
                if (t.lastComment == UserMode.Employee && (t.ticketStatus == TicketStatus.InProgress || t.ticketStatus == TicketStatus.ToDo) && t.commentCount > 1)
                  t.lastComment = UserMode.Employee;
                if (t.ticketStatus == TicketStatus.Unassigned || t.ticketStatus == TicketStatus.Closed || t.commentCount == 1)
                  t.lastComment = UserMode.MeetingRoomApp;
                if ((t.commentCount > 1 && t.lastComment == UserMode.CustomerEmployee) || (t.lastComment == UserMode.CustomerEmployee && t.ticketStatus == TicketStatus.Done))
                  t.lastComment = UserMode.CustomerEmployee;
              }
              else
                this.result = result;
            }).finally(() => {
              this.isBusy = false;
            });
          })
          this.getTicketType();
        }
        else
          this.result = result;
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }


  public getTicketType(): void {

    this.getTicketTypesInput.paginationInformation.currentPage = 0;
    this.getTicketTypesInput.sortOrder == SortOrder.Ascending;

    this.ticketTypeService.getTicketTypes(this.getTicketTypesInput, 'dashboardToken').then(result => {
      if (result.success == true) {
        this.ticketTypeResultList = result;
      }
      else
        this.result = result;
    }).finally(() => {
      this.isBusy = false;
    });
  }

  public onPageChange(currentPage: number): void {
    if (this.isBusy == false) {
      this.getTicketsInput.paginationInformation.currentPage = currentPage;
      this.loadData();
    }
  }

  public onSortChange(sortType: TicketSortType): void {
    if (this.isBusy == false) {
      if (this.getTicketsInput.sortOrder == SortOrder.Ascending)
        this.getTicketsInput.sortOrder = SortOrder.Descending;
      else
        this.getTicketsInput.sortOrder = SortOrder.Ascending;
      this.getTicketsInput.sortType = sortType;
      this.loadData();
    }
  }

  public showComments(ticketCommentModal:any,item: TicketResult): void {
    const token = Utility.getTokenType();

    //this.ticket = item;
    this.isTicketLoaded = false;
    this.ticketService.getTicket(item.id, token).then(result => {
      if (result.success === true) {
        this.ticket = result.data;
        this.isTicketLoaded = true;
      } else {
        this.result = result;
      }
    });
    this.modalService.open(ticketCommentModal, {
      centered: true,
      size: 'xl',
      windowClass: 'modal modal-info'
    });
  }

  public getProjectsWithCustomerId(): void {
    this.getTicketsInput.projectId = null;
    this.projectList = new Array<ProjectResult>();
    if (this.getTicketsInput.customerId !== null) {
      this.projectService.getProjectsWithCustomerId(this.getTicketsInput.customerId ?? 0, this.token)
        .then(result => {
          if (result.success == true) {
            this.projectList = result.data;
          }
          else
            this.result = result;
        });
    }
  }


  public loadEmployees() {
    this.employeeService.getEmployeeDropdown()
      .then(result => {
        if (result.success == true) {
          this.employeeDropdown = result.data;
        }
        else
          this.result = result;
      });
  }

  public onTicketHasChanged(val: TicketHasChangedEventInput): void {
    this.loadData();
  }

  public demonstrateTicketHistory(ticketHistoryModal: any, id: number): void {
    if (this.isBusy === false) {
      this.ticketIdForHistory = id;
      this.modalService.open(ticketHistoryModal, {
        centered: true,
        size: 'lg',
        windowClass: 'modal modal-info'
      });
    }
  }

  public assignedEmployeeHistory(assignedEmployeeModal: any, id: number): void {
    if (this.isBusy === false) {
      this.clientIdForAssignedEmployee = id;
      this.modalService.open(assignedEmployeeModal, {
        centered: true,
        size: 'lg',
        windowClass: 'modal modal-info'
      });
    }
  }

  public downloadExcel(): void {
    this.getTicketsInput.paginationInformation.totalCount = this.ticketResultList.paginationInformation.totalCount;
    this.ticketService.getTicketsExportToExcel(this.getTicketsInput).then(result => {
      if (result.success === false) {
        this.result = result;
      }
      else {
        Utility.convertAndDownloadExcel(result.data.toString());
      }
    });
  }

  public dateOptions: FlatpickrOptions = {
    enableTime: false,
    altInput: true,
    time_24hr: true,
    altFormat: 'Y-m-d'
  };
}
